import { IErknmAgreementApprove } from 'APIPackage/KnmModule/interfaces/IErknmAgreementApprove';
import { convertInitialKnmDateToFormDate } from 'KnmPackage/MainModule/common/convertInitialKnmDateToFormDate';
import { DATE_FORMAT_LONG_FNS, SYSTEM_DATE_FORMAT_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { handleReactQuillDeltaValue } from 'functions/handleReactQuillDeltaValue';

import { IErknmFormAgreementApprove } from '../interfaces/IErknmFormAgreementApprove';
import { approvedSelectOptions } from '../constants/approvedSelectOptions';

export const convertAgreementsApproveToFormValues = (
  approveInfo: IErknmAgreementApprove | null | undefined,
): IErknmFormAgreementApprove | undefined => {
  return {
    approved: !approveInfo?.approved
      ? undefined
      : approvedSelectOptions.find(item => item.value === approveInfo?.approved),
    note: handleReactQuillDeltaValue(approveInfo?.note || undefined),
    numberDecision: approveInfo?.numberDecision || undefined,
    dateDecision: convertInitialKnmDateToFormDate(
      approveInfo?.dateDecision,
      DATE_FORMAT_LONG_FNS,
      SYSTEM_DATE_FORMAT_FNS,
    ),
    whoMadeDecision: approveInfo?.whoMadeDecision || undefined,
    titleSigner: approveInfo?.titleSigner || undefined,
    reasonForRefusal: handleReactQuillDeltaValue(approveInfo?.reasonForRefusal || undefined),
    attachment: approveInfo?.attachment ? [approveInfo.attachment] : undefined,
  };
};
